export const META_TYPE = 'scheduleOverview';
export const META_VER = 'v1';

export const CMD_SCHEDULE_OVERVIEW_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
